import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { IWebEditPublishedConnectionAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { editPublishedConnection } from '../actions/EditPublishedConnectionReduxAction';

export const EditPublishedConnectionEntityAction: IEntityAction<IContentInfo<'virtualConnection'>, IWebEditPublishedConnectionAction> = {
  name: EntityActionNames.EditPublishedConnection,
  translateName: Messages.editPublishedConnection,
  isVisible: () => FeatureFlags.publishedConnectionEditorEnabled,
  isClickable: (availableActions: IWebEditPublishedConnectionAction) => !!availableActions && availableActions.webEditPublishedConnection,
  createReduxAction: (targetItems: IContentInfo[]) => editPublishedConnection(targetItems[0])
};
